export default function Services() {
  const services = [
    {
      icon: 'ri-file-text-line',
      title: 'Tax Returns & Planning',
      description: 'Comprehensive self-assessment and corporation tax returns, strategic tax planning, and full HMRC compliance support to minimize your tax liability legally.',
      features: ['Self-Assessment Returns', 'Corporation Tax', 'Tax Planning Strategies', 'HMRC Compliance'],
      color: 'from-blue-500 to-blue-600'
    },
    {
      icon: 'ri-book-line',
      title: 'Bookkeeping & Accounting',
      description: 'Professional bookkeeping services including monthly reconciliation, financial statements, management accounts, and year-end accounts preparation.',
      features: ['Monthly Bookkeeping', 'Financial Statements', 'Management Accounts', 'Year-End Accounts'],
      color: 'from-indigo-500 to-indigo-600'
    },
    {
      icon: 'ri-receipt-line',
      title: 'VAT Services',
      description: 'Complete VAT support from registration to quarterly returns, Making Tax Digital (MTD) compliance, and strategic VAT planning for your business.',
      features: ['VAT Registration', 'Quarterly VAT Returns', 'MTD Compliance', 'VAT Planning'],
      color: 'from-purple-500 to-purple-600'
    },
    {
      icon: 'ri-team-line',
      title: 'Payroll Services',
      description: 'Full payroll management including PAYE setup, payroll processing, pension auto-enrolment administration, and Real Time Information submissions.',
      features: ['PAYE Setup', 'Payroll Processing', 'Pension Auto-Enrolment', 'RTI Submissions'],
      color: 'from-cyan-500 to-cyan-600'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Business Advisory',
      description: 'Strategic business support including startup guidance, financial forecasting, cash flow management, and growth planning to help your business thrive.',
      features: ['Startup Support', 'Financial Forecasting', 'Cash Flow Management', 'Strategic Planning'],
      color: 'from-teal-500 to-teal-600'
    },
    {
      icon: 'ri-building-line',
      title: 'Company Formation',
      description: 'Complete company formation services including limited company registration, business structure advice, and all necessary Companies House filings.',
      features: ['Company Registration', 'Structure Advice', 'Companies House Filings', 'Compliance Support'],
      color: 'from-emerald-500 to-emerald-600'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-service-line text-blue-600"></i>
            <span className="text-blue-600 text-sm font-semibold">Our Services</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Comprehensive Financial Solutions
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We offer a complete range of accounting and tax services designed specifically for UK businesses of all sizes
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:-translate-y-2 group"
            >
              <div className={`w-16 h-16 bg-gradient-to-br ${service.color} rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <div className="space-y-3">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-checkbox-circle-fill text-green-500 text-lg"></i>
                    </div>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </div>
                ))}
              </div>

              <button 
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className="mt-6 w-full bg-gray-50 text-gray-700 py-3 rounded-lg hover:bg-blue-600 hover:text-white transition-all flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap font-semibold"
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-800 rounded-2xl p-12 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Not Sure Which Service You Need?
          </h3>
          <p className="text-blue-100 text-lg mb-8 max-w-2xl mx-auto">
            Our expert team is here to help. Get a free consultation to discuss your specific needs and find the perfect solution for your business.
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg hover:bg-blue-50 transition-all shadow-lg hover:shadow-xl inline-flex items-center gap-2 cursor-pointer whitespace-nowrap text-lg font-semibold"
          >
            Schedule Free Consultation
            <i className="ri-calendar-line text-xl"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
